import React, { FC, useEffect, useState } from "react";
import LoginContainer from "../default-container/LoginContainer";
import Icon from "../../atoms/icon/Icon";
import { IconType } from "../../../lib/helpers/constants/iconTypes";

import { ReactComponent as Logo } from "../../../assets/images/bvlogo.svg";
import  LogoWe  from "../../../assets/images/wefox.png";
export interface ILoginLayoutProps {
  children: React.ReactNode;
}

const LoginLayout: FC<ILoginLayoutProps> = ({ children }) => {
  const [FullUrl, setFullUrl] = useState("");

  useEffect(() => {
    const domain = window.location.origin;

    setFullUrl(domain);
  }, []);

  return (
    <div className="min-h-screen relative bg-white">
      <div className="hidden md:block rounded-tl-[40%] sm:rounded-tl-[70%] absolute right-0 top-[90%] md:top-10 bg-theme h-[calc(100%_-_40px)] w-full md:w-1/2">

      </div>
      <div className="flex flex-col justify-center items-center h-full py-10 2xl:py-20 min-h-screen relative z-10">
        <LoginContainer>
          {FullUrl === "https://berner.insuhub.ch" ? (

            <Logo className="max-w-[150px] md:max-w-[250px] w-full h-auto md:h-[150px] object-cover m-auto" />
          ) : 
          FullUrl === "https://wefox.insuhub.ch" ? (
            <>
              <img src={LogoWe} className="max-w-[150px] md:max-w-[250px] w-full h-auto md:h-[150px] object-contain m-auto" alt="" />
            </>
          ) : (
            <Icon
              iconType={IconType.COLORFUL_LOGO_ICON}
              className="max-w-[150px] md:max-w-[250px] w-full h-auto md:h-[150px] object-cover m-auto"
            />
          )}

          <div>{children}</div>
        </LoginContainer>
      </div>
       <div className="block md:hidden rounded-tl-[70%] absolute right-0 bottom-0 bg-theme h-[100px] w-[90%]">

      </div>
    </div>
  );
};

export default LoginLayout;
